<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="500px" :fullscreen="$vuetify.breakpoint.smAndDown">
        <template v-slot:activator="{ on }">
            <slot name="activator" :on="on" />
        </template>
        <v-card v-if="dialog" flat outlined rounded>
            <v-card-title class="text-h6 justify-center">
                <span class="body-font-family gray--text text--darken-5">{{ $t('Select folder') }}</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <radio-group v-model="groupModel" :disabled="disableButtons" v-if="!loading">
                    <template v-for="activityGroup of orderedGroups">
                        <radio-item
                            :key="activityGroup.id"
                            :item="{
                                label: activityGroup.name,
                                value: activityGroup.id,
                            }"
                        />
                        <span class="pl-8 mb-3 caption" :key="`span-${activityGroup.id}`">
                            {{ activityGroup.activities.length }} {{ $t('Quests') }}
                        </span>
                    </template>
                </radio-group>
                <template v-if="loading">
                    <template v-for="n in 15">
                        <v-skeleton-loader type="list-item" :key="`loader-${n}`" />
                    </template>
                </template>
            </v-card-text>

            <v-card-actions class="mx-3">
                <v-btn
                    class="primary--text"
                    x-large
                    width="49%"
                    :disabled="disableButtons"
                    depressed
                    @click="dialog = false"
                >
                    {{ $t('Cancel') }}
                </v-btn>
                <v-btn
                    color="primary"
                    x-large
                    width="49%"
                    :disabled="disableButtons"
                    depressed
                    @click="updateQuestGroup"
                >
                    {{ $t('MOVE') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { ActivityModel } from '../models';

export default {
    props: {
        quests: {
            type: Array,
        },
        activityGroupId: {
            type: Number,
        },
        refreshAction: {
            type: Function,
        },
    },
    data() {
        return {
            loading: false,
            dialog: false,
            disableButtons: false,
            selectedGroup: null,
        };
    },
    computed: {
        ...mapState('organization', ['selectedOrganizationID']),
        ...mapGetters('questList', ['orderedGroups']),
        groupModel: {
            get() {
                return this.selectedGroup || this.activityGroupId;
            },
            set(activityGroup) {
                this.selectedGroup = activityGroup;
            },
        },
    },
    methods: {
        ...mapActions('questList', ['loadActivityGroups', 'moveQuestToAGroup']),
        updateQuestGroup() {
            this.disableButtons = true;
            if (this.selectedGroup !== this.activityGroupId) {
                const promises = [];
                this.quests.forEach(questId => {
                    promises.push(this.moveQuestToAGroup({ questId, groupId: this.selectedGroup }));
                });
                Promise.allSettled(promises).then(() => {
                    this.dialog = false;
                    this.$emit('quest-moved');
                    this.disableButtons = false;
                });
            } else {
                this.dialog = false;
            }
        },
    },
    watch: {
        dialog(dialog) {
            if (dialog) {
                this.disableButtons = true;
                this.loadActivityGroups().finally(() => {
                    this.disableButtons = false;
                });
            }
        },
    },
};
</script>
